import React from "react";
import cn from "classnames";
import styles from "./toggle-button.module.scss";

interface ToggleButtonPropTypes {
  isActive: boolean;
  handleClick: () => void;
  disabled?: boolean;
}

const cssClassName = "gradient-toggle-button";

export const ToggleButton = ({
  isActive,
  handleClick,
  disabled = false,
}: ToggleButtonPropTypes) => {
  return (
    <button
      disabled={disabled}
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--active`]]: isActive,
      })}
      onClick={handleClick}
    >
      <span
        className={cn(styles[`${cssClassName}__circle`], {
          [styles[`${cssClassName}__circle--active`]]: isActive,
        })}
      />
    </button>
  );
};
